export default {
  loading: false,
  loadingExporting: false,
  invoicePeriods: [],
  form: {
    month_report: '',
    date_range: {
      start: '',
      end: '',
    },
  },
};



// WEBPACK FOOTER //
// ./src/features/private/client-environment/pages/invoice-extract/store/states.js